import React from 'react';
import Lottie, { LottieProps, Options } from 'react-lottie';
import loading from '@graphic/loading.json';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loading,
};

const WritingMotion = (props: Omit<LottieProps, 'options'> & { options?: Options }) => {
  return <Lottie {...props} options={props.options ? props.options : defaultOptions} isClickToPauseDisabled={true} />;
};

export default WritingMotion;

interface RowWritingMotionProps {
  width?: number;
  height?: number;
  size?: number;
}

export const RowWritingMotion = ({ width = 24, height = 24, size = 6 }: RowWritingMotionProps) => {
  return (
    <div className={cx('typing')} style={{ width, height }}>
      <div className={cx('dot')} style={{ width: size, height: size }} />
      <div className={cx('dot')} style={{ width: size, height: size }} />
      <div className={cx('dot')} style={{ width: size, height: size }} />
    </div>
  );
};
